import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Button, Card, CardImg, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { sort } from "fast-sort";
import QRCode from "qrcode";
import { getDeliveryStatusColor, splitDeliveryRemark } from "../functions/Delivery";
import { addPhoneLink, getDateString, getImageType, isEmpty, resizeFile } from "../functions/Utility";
import { addInvoiceProofImage, deleteInvoiceProofImage, getBillPaymentImage, getBillStatusColor, getInvoiceProofImage } from "../functions/Bill";
import GeneralPhotoArea from './components/GeneralPhotoArea';
import { addReceiptImage, deleteReceiptImage, getReceiptImage } from '../functions/Receipt';
import GeneralConfirmModal from './GeneralConfirmModal';
import SpinnerOverlay from './components/SpinnerOverlay';
import { addSystemLog } from '../functions/SystemLog';
import { getUserById, getUserId } from '../functions/Auth';


function BillRecordDetailModal(props) {
    const { isOpen, toggle, invoiceData } = props;

    const [isLoading, setIsLoading] = React.useState(false);
    //  QR code
    const [invoiceUrlQrCode, setInvoiceUrlQrCode] = React.useState("");
    //  Payment Image
    const [paymentImageData, setPaymentImageData] = React.useState([]);

    // Invoice photo
    //for local use
    const [invoiceProofPhotoDataBase64, setInvoiceProofPhotoDataBase64] = React.useState("");

    // Photo data Array
    // Structure: 
    // [{receiptID: XXXXXXXX, base64Data: YYYYYYYYY}, ......]
    const [receiptPhotoDataBase64Array, setReceiptPhotoDataBase64Array] = React.useState([]);

    const [receiptIDSelected, setReceiptIDSelected] = React.useState('');

    const [deleteReceiptPhotoModalIsOpen, setDeleteReceiptPhotoModalIsOpen] = React.useState(false);
    const [deleteInvoiceProofPhotoModalIsOpen, setDeleteInvoiceProofPhotoModalIsOpen] = React.useState(false);

    React.useEffect(() => {
        if (!invoiceData || isEmpty(invoiceData)) return;
        //  Initial API call
        const initData = async () => {
            let paymentImageData, invoiceQrCode;
            setIsLoading(true);
            paymentImageData = await getBillPaymentImage(invoiceData.paymentID);
            setPaymentImageData(paymentImageData);
            if (invoiceData.invoiceUrl) {
                invoiceQrCode = await QRCode.toDataURL(invoiceData.invoiceUrl);
                setInvoiceUrlQrCode(invoiceQrCode);
            }
            refreshInvoicePhotoDataFromDB().then();
            refreshReceiptPhotoDataFromDB().then();
            setIsLoading(false);
        };
        initData().then();

    }, [invoiceData]);


    const refreshInvoicePhotoDataFromDB = async () => {
        // deliveryPhoto fro(m backend
        getInvoiceProofImage(invoiceData.paymentID).then((photoData) => {
            setInvoiceProofPhotoDataBase64(photoData.ImageBase64Content);

        });

    }

    const refreshReceiptPhotoDataFromDB = async () => {
        if (invoiceData.ReceiptBillTotalMatches && Array.isArray(invoiceData.ReceiptBillTotalMatches) && invoiceData.ReceiptBillTotalMatches.length >= 1) {
            let arrayToUse = invoiceData.ReceiptBillTotalMatches;
            let photoArrayToSet = [];

            for (let index = 0; index < arrayToUse.length; index++) {
                const element = arrayToUse[index];
                // from backend
                let photoData = await getReceiptImage(element.receiptID);
                photoArrayToSet.push({ receiptID: element.receiptID, base64Data: photoData.ImageBase64Content });
            };

            setReceiptPhotoDataBase64Array(photoArrayToSet);

        } else {
            setReceiptPhotoDataBase64Array([]);
        }
    }

    const getReciptImageBase64ByReceiptID = (receiptID) => {

        if (receiptPhotoDataBase64Array && Array.isArray(receiptPhotoDataBase64Array) && receiptPhotoDataBase64Array.length >= 1) {
            let foundData = receiptPhotoDataBase64Array.find(item => item.receiptID === receiptID);
            if (foundData) {
                return foundData.base64Data;
            } else {
                return '';
            }
        } else {
            return '';
        }

    }

    // upload receipt image
    const uploadReceiptPhotoCmd = async (receiptIDToUse, imageToUpload) => {
        setIsLoading(true);
        //resize file will auto encoded to base 64
        let imageToUploadResized = await resizeFile(imageToUpload);
        let imageBase64 = imageToUploadResized;
        let imageBase64HeaderRemoved = imageBase64.split(',')[1];
        // remove the header from the image
        await addReceiptImage(receiptIDToUse, imageBase64HeaderRemoved);

        await addSystemLog(getUserId(), "3001", receiptIDToUse, "WEB-新增收據圖");

        await refreshReceiptPhotoDataFromDB();
        setIsLoading(false);
    };

    // delete invoice proof
    const deleteReceiptPhotoCmd = async (receiptIDToUse) => {
        setIsLoading(true);
        await deleteReceiptImage(receiptIDToUse);

        await addSystemLog(getUserId(), "3003", receiptIDToUse, "WEB-刪除收據圖");

        await refreshReceiptPhotoDataFromDB();
        setIsLoading(false);
    };




    // upload invoice proof
    const uploadInvoiceProofImageCmd = async (paymentIDToUse, imageToUpload) => {
        setIsLoading(true);
        //resize file will auto encoded to base 64
        let imageToUploadResized = await resizeFile(imageToUpload);
        let imageBase64 = imageToUploadResized;
        let imageBase64HeaderRemoved = imageBase64.split(',')[1];
        // remove the header from the image
        await addInvoiceProofImage(paymentIDToUse, imageBase64HeaderRemoved);
        await refreshInvoicePhotoDataFromDB();
        setIsLoading(false);
    };

    // delete invoice proof
    const deleteInvoiceProofPhotoCmd = async (paymentIDToUse) => {
        setIsLoading(true);
        await deleteInvoiceProofImage(paymentIDToUse);
        await refreshInvoicePhotoDataFromDB();
        setIsLoading(false);
    };



    return invoiceData ? (
        <Modal isOpen={isOpen} toggle={toggle}>
            {isLoading ? <SpinnerOverlay /> : ""}

            <ModalHeader toggle={toggle}>
                <div className="pt-2">
                    {addPhoneLink(invoiceData.customerName)}
                </div>
                <Typography variant="h4" component="h2">
                    <strong>$ {invoiceData.netPrice}</strong>
                </Typography>
                <Typography className='mt-2' color="textSecondary">
                    <strong className={"bg-" + getBillStatusColor(invoiceData.billStatus) + " p-1 text-dark"}>{invoiceData.billStatus}</strong>
                    <span className='pl-2'></span>
                    {invoiceData.deliveryRecords && Array.isArray(invoiceData.deliveryRecords) &&
                        <strong className={"bg-danger p-1 text-dark"}>
                            {invoiceData.deliveryRecords.length}{'送貨'}
                        </strong>}

                    <span className='pl-2'></span>
                    {invoiceData.ReceiptBillTotalMatches && Array.isArray(invoiceData.ReceiptBillTotalMatches) &&
                        <strong className={"bg-info p-1 text-dark"}>
                            {invoiceData.ReceiptBillTotalMatches.length}{'付款'}
                        </strong>}
                </Typography>



                <Typography color="textSecondary">
                    <strong>{invoiceData.paymentID}</strong>
                </Typography>
                {invoiceData.remark && invoiceData.remark !== '' && splitDeliveryRemark(invoiceData.remark).map((remark, index) => (
                    <Typography key={`${invoiceData.paymentID}-remark-${index}`} className="pl-2 pt-2 m-0 text-danger" color="textSecondary">
                        <strong>{addPhoneLink(remark)}</strong>
                    </Typography>
                ))}
            </ModalHeader>
            <ModalBody>
                <Container style={{
                    color: "black",
                    border: "1px solid rgba(0,0,0,.125)",
                    borderRadius: ".25rem",
                }}>
                    <Row className="bg-secondary pt-2 pb-2">
                        <Col xs={6}>項目內容</Col>
                        <Col xs={2} className="p-0">單件</Col>
                        <Col xs={2} className="p-0">數目</Col>
                        <Col xs={2} className="p-0">價格</Col>
                    </Row>
                    {invoiceData.goods && Array.isArray(invoiceData.goods) && invoiceData.goods.length >= 1 && invoiceData.goods.map((good) => (
                        <Row key={`${invoiceData.paymentID}-good-${good.goodID}`} className="pt-2 pb-2">
                            <Col xs={6}>
                                <div>{good.goodDescription}</div>
                                {good.remarks !== "" ? (
                                    <div className="pl-2 text-danger">{good.remarks}</div>
                                ) : ""}
                            </Col>
                            <Col xs={2} className="p-0">${good.unitPrice}</Col>
                            <Col xs={2} className="p-0">{good.quantity + " " + good.goodUnit}</Col>
                            <Col xs={2} className="p-0">${good.subItemPrice}</Col>
                        </Row>
                    ))}
                </Container>
                {invoiceData.customerPhoneList && Array.isArray(invoiceData.customerPhoneList) && invoiceData.customerPhoneList.length > 0 ? (
                    <Container className="mt-2" style={{
                        color: "black",
                        border: "1px solid rgba(0,0,0,.125)",
                        borderRadius: ".25rem",
                    }}>
                        <Row className="bg-secondary pt-2 pb-2">
                            <Col xs={6}>聯絡人</Col>
                            <Col xs={6} className="p-0">電話</Col>
                        </Row>
                        {sort(invoiceData.customerPhoneList).desc(u => u.priority).map((customerPhone) => (
                            <Row key={`${invoiceData.paymentID}-customer-phone-${customerPhone.phoneNumber}`}
                                className="pt-2 pb-2">
                                <Col xs={6}>{customerPhone.phoneUserName}</Col>
                                <Col xs={6} className="p-0">
                                    {addPhoneLink(customerPhone.phoneNumber)}
                                </Col>
                            </Row>
                        ))}
                    </Container>
                ) : ""}



                <Container>
                    <Row className="m-2 justify-content-center">
                        <a target="_blank" rel="noreferrer" href={invoiceData.invoiceUrl}>
                            <img src={invoiceUrlQrCode} alt="invoice-qr-code" />
                        </a>
                    </Row>
                </Container>




                <Typography className="mb-2 text-center" variant="h6" color="textSecondary" gutterBottom>
                    <strong className="text-dark">自提証明</strong>{' '}
                </Typography>
                <Row className="pb-2">
                    <Col>
                        <GeneralPhotoArea
                            photoID={invoiceData.paymentID}
                            photoDataBase64={invoiceProofPhotoDataBase64}
                            onUploadImage={async (fileToUpload) => {
                                await uploadInvoiceProofImageCmd(invoiceData.paymentID, fileToUpload)
                            }}
                            onDeleteImage={() => {
                                setDeleteInvoiceProofPhotoModalIsOpen(true);
                            }}
                        />
                    </Col>
                </Row>






                <Typography className="mb-2 text-center" variant="h6" color="textSecondary" gutterBottom>
                    <strong className="text-dark">付款記錄</strong>{' '}
                </Typography>
                <Container style={{
                    color: "black",
                    border: "1px solid rgba(0,0,0,.125)",
                    borderRadius: ".25rem",
                }}>
                    <Row style={{ backgroundColor: "#d9e2ef" }} className="pt-2 pb-2 text-left">
                        <Col xs={2} >付款金額</Col>
                        <Col xs={2} className="pl-0">收據金額</Col>
                        <Col xs={2} className="pl-0">方式</Col>
                        <Col xs={2} className="pl-0">狀態</Col>
                        <Col xs={3} className="pl-0">時間</Col>
                        <Col xs={1} className="pl-0"></Col>
                    </Row>
                    {invoiceData.ReceiptBillTotalMatches && Array.isArray(invoiceData.ReceiptBillTotalMatches) && invoiceData.ReceiptBillTotalMatches.length >= 1 && invoiceData.ReceiptBillTotalMatches.map((receiptMatchItem) => (
                        <div key={`${receiptMatchItem.receiptID}`}>
                            <Row className="pt-2 pb-2">
                                <Col xs={2} >${receiptMatchItem.paidAmount}</Col>
                                <Col xs={2} className="pl-0">${receiptMatchItem.Receipt.receiptNetPrice}</Col>
                                <Col xs={2} className="pl-0">{receiptMatchItem.Receipt.receiptPaymentMethod}</Col>
                                <Col xs={2} className="pl-0">{receiptMatchItem.Receipt.receiptStatus}</Col>
                                <Col xs={3} className="pl-0">{getDateString(receiptMatchItem.Receipt.receiptRecordDateTime, true, false)}</Col>
                                <Col xs={1} className="p-0 text-dark">
                                    <a href={receiptMatchItem.Receipt.receiptURL}><i className="fas fa-qrcode" /></a>
                                </Col>
                            </Row>

                            <Row key={`${receiptMatchItem.receiptID}`} className="pt-2 pb-2">
                                <Col>
                                    <Typography color="textSecondary">
                                        <span>付款圖：</span>
                                    </Typography>
                                    <GeneralPhotoArea
                                        photoID={receiptMatchItem.receiptID}
                                        photoDataBase64={getReciptImageBase64ByReceiptID(receiptMatchItem.receiptID)}
                                        onUploadImage={async (fileToUpload) => {
                                            await uploadReceiptPhotoCmd(receiptMatchItem.receiptID, fileToUpload)
                                        }}
                                        onDeleteImage={() => {
                                            setReceiptIDSelected(receiptMatchItem.receiptID);
                                            setDeleteReceiptPhotoModalIsOpen(true);
                                        }}
                                    />
                                </Col>
                            </Row>

                        </div>
                    ))}
                </Container>



                <Typography className="mt-4 mb-2 text-center" variant="h6" color="textSecondary" gutterBottom>
                    <strong className="text-dark">送貨記錄</strong>{' '}
                </Typography>
                <Container style={{
                    color: "black",
                    border: "1px solid rgba(0,0,0,.125)",
                    borderRadius: ".25rem",
                }}>
                    <Row style={{ backgroundColor: "#d9e2ef" }} className="pt-2 pb-2">
                        <Col xs={5}>送貨時間</Col>
                        <Col xs={4} className="p-0">地址</Col>
                    </Row>
                    {invoiceData.deliveryRecords && Array.isArray(invoiceData.deliveryRecords) && invoiceData.deliveryRecords.length >= 1 && invoiceData.deliveryRecords.map((delivery) => (
                        <Row key={`${invoiceData.paymentID}-delivery-${delivery.deliveryID}`} className="pt-2 pb-2">
                            <Col xs={5}>{delivery.proposedDateTime}</Col>
                            <Col xs={4} className="pl-0">{delivery.address}</Col>
                            <Col xs={2} className="p-0">
                                <strong className={"bg-" + getDeliveryStatusColor(delivery.deliveryStatus) + " p-1 text-dark"}>
                                    {delivery.deliveryStatus.substring(0, 2)}
                                </strong>
                            </Col>
                            <Col xs={1} className="p-0 text-dark">
                                <a href={delivery.deliveryNoteUrl}><i className="fas fa-qrcode" /></a>
                            </Col>
                        </Row>
                    ))}
                </Container>







                {/* 
                <Typography className="mt-3 mb-2 text-center" variant="h6" color="textSecondary" gutterBottom>
                    <strong className="text-dark">入數記錄</strong>{' '}
                </Typography>
                {paymentImageData.map((image) => (
                    <Card style={{ border: "none" }}>
                        <CardImg bottom width="100%"
                            src={`data:${getImageType(image.ImageBase64Content).mime};base64,${image.ImageBase64Content}`}
                            alt={`bill-payment-${invoiceData.paymentID}-image`} />
                    </Card>
                ))} */}

            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={toggle}>OK</Button>
            </ModalFooter>

            <GeneralConfirmModal isOpen={deleteReceiptPhotoModalIsOpen}
                headerText={'確認刪除？'}
                toggle={() => setDeleteReceiptPhotoModalIsOpen(false)}
                onSubmit={async () => {
                    await deleteReceiptPhotoCmd(receiptIDSelected);
                    setDeleteReceiptPhotoModalIsOpen(false);
                }} />

            <GeneralConfirmModal isOpen={deleteInvoiceProofPhotoModalIsOpen}
                headerText={'確認刪除？'}
                toggle={() => setDeleteInvoiceProofPhotoModalIsOpen(false)}
                onSubmit={async () => {
                    await deleteInvoiceProofPhotoCmd(invoiceData.paymentID);
                    setDeleteInvoiceProofPhotoModalIsOpen(false);
                }} />

        </Modal>
    ) : <div />;
}

export default BillRecordDetailModal
